import "./Home.module.css";
import VisualCommunicationHeader from "@/reusable_sections/Header";
import TheOlfactoryExperience from "./sections/TheOlfactoryExperience";
import TrustBar from "./sections/TrustBar";
import TheCookieCategories from "./sections/TheCookieCategories";
import LeNostreRicettePiuAmate from "./sections/LeNostreRicettePiuAmate";
import SeoAndAnalytics from "./sections/SeoAndAnalytics";
import ReadyForYourNewSignboard from "./sections/ReadyForYourNewSignboard";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VisualCommunicationHeader />
      <TheOlfactoryExperience />
      <TrustBar />
      <TheCookieCategories />
      <LeNostreRicettePiuAmate />
      <SeoAndAnalytics />
      <ReadyForYourNewSignboard />
      <Footer />
    </div>;
}